import { render, staticRenderFns } from "./SimulationBridalItem.vue?vue&type=template&id=89401850"
import script from "./SimulationBridalItem.vue?vue&type=script&lang=js"
export * from "./SimulationBridalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports